import React from "react";

import MyValue from '../img/myvalue.png';
import MyValueLogo from '../img/myvaluelogo.png';


class Products extends React.Component {
  render() {
    return (
      <div class="container d-flex h-100">
        <div class="align-self-center w-100 row">
          <div class = 'col-lg-12 col-md-12 offset-lg-3'>
            <h1 class = 'jobs-moving-title jobs-heading-title'>Our Products</h1>
          </div>
          <div class ="col-lg-3 col-md-6 offset-lg-3">
            <div class = 'product-content-container h-100'>
              <div>
                <img class = 'product-spotlight' src = {MyValue} width = '100%' style = {{marginTop: '15px'}}/>
              </div>
            </div>
          </div>
          <div class ="col-lg-6 col-md-6">
            <div class = 'product-content-container h-100'>
              <p class = 'people-paragraph h-100'>
                <div class = 'd-flex h-100'>
                  <div class = 'align-self-center'>
                    <img src = {MyValueLogo} width = '50%'/>
                    <h4 class = 'community-title-modifier people-quote article-title'>Aplikasi loyalty dan reward dari grup KompasGramedia. </h4>
                      <p>MyValue adalah bentuk transformasi loyalty program digital dari membership berbasis kartu Kompas Gramedia Value Card (KGVC). MyValue ingin memberikan pengalaman berbelanja yang semakin menarik kepada seluruh pelanggan Kompas Gramedia. </p>
                    <div style = {{height:'5px', width: '50px', marginTop: '20px', backgroundColor:'#e0df87'}} />
                  </div>
                </div>
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Products;



// WEBPACK FOOTER //
// ./src/components/Products.js